import request from '../request'

/*
  开发票相关接口
  331583    代购开发票接口
*/
export default {
  '331583': (params) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: Object.assign({
        pid: 331583
      }, params),
      sidFields: ['uid', 'pid']
    })
}



// WEBPACK FOOTER //
// ./src/api/invoice.js